<template>
  <div class="pi-modal__container">
    <PIModalHeader :position="position" />
    
    <PIModalControls :position="position" />

    <PIModalFooter
      :positionNumber="position.positionNumber"
      @update:show-pi-modal="$emit('update:show-pi-modal', $event)" />
  </div>  
</template>

<script>
import PIModalHeader from "@/components/ThePlayerInstructionModalHeader";
import PIModalControls from "@/components/ThePlayerInstructionControls.vue"
import PIModalFooter from "@/components/ThePlayerInstructionModalFooter";

export default {
  components: {
    PIModalHeader,
    PIModalControls,
    PIModalFooter,
  },

  props: {
    position: Object,
  },

  data: function() {
    return {

    };
  },

  methods: {
  }
}
</script>

<style scoped>
.pi-modal__container {
  position: fixed;
  background: #121212;
  padding: 16px 12px 8px;
  box-sizing: border-box;
  display: none;
  flex-direction: column;
  justify-content: space-between;
  max-width: 1500px;
}

@media only screen and (min-width: 740px) {
  .pi-modal__container {
    display: flex;
    left: 0;
    top: 50%;
    transform: translate(0%, -50%);
    width: 100vw;
  }
}

@media only screen and (min-width: 1340px) {
  .pi-modal__container {
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70vw;
    border-radius: 12px;
  }
}
</style>
